import { render, staticRenderFns } from "./PriceRule.vue?vue&type=template&id=2e2c2ba0&"
import script from "./PriceRule.vue?vue&type=script&lang=js&"
export * from "./PriceRule.vue?vue&type=script&lang=js&"
import style0 from "./PriceRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports